import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class FactoryProductDepositSetting implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fFactoryId: string,
    private fProductId: string,
    private fDepositPercent: number
  ) {
    if (
      fId === undefined ||
      fFactoryId === undefined ||
      fProductId === undefined ||
      fDepositPercent === undefined
    ) {
      throw new Error("Product deposit settings require all values");
    }
  }

  get id(): string {
    return this.fId;
  }

  get factoryId(): string {
    return this.fFactoryId;
  }

  get productId(): string {
    return this.fProductId;
  }

  get depositPercent(): number {
    return this.fDepositPercent;
  }
}
